import { createSlice } from "@reduxjs/toolkit"
import Cookies from "js-cookie";



const initialState={
    //history data
    data:[],
    currentAdmin:null,
    currentTheme:true,
    currentTerminals:[],
    statusCount:0,
    tickets:[],
    currentUsers:[[],[]],
    currentAdmins:[],
    currentTerminal:{},
    detailStatusList:[],
    isLogin:false,
}

const adminSlice=createSlice({
name:'admin',

initialState,
reducers:{
    loginStart:(state)=>{

    },
    loginSuccess:(state,{payload})=>{
        state.isLogin=true;
        state.currentAdmin=payload;
        

    },
    addTerminalList:(state,{payload})=>{
        state.currentTerminals=payload

    },
    updateTerminal:(state,{payload})=>{
        state.currentTerminal=payload
    },
    TicketList:(state,{payload})=>{
        state.tickets=payload
    },
    changeThemeShow:(state,{payload})=>{
        state.currentTheme=payload
    },
    setUsers:(state,{payload})=>{
        state.currentUsers=payload
    },
    setStatusCount:(state,{payload})=>{
        state.statusCount=payload
    },
    addTohistories:(state,{payload})=>{
        state.data=payload
    },
    addDetailStatusList:(state,{payload})=>{
        state.detailStatusList=payload
    },
    addAdmin:(state,{payload})=>{
        state.currentAdmins=[payload,...state.currentAdmins]
    },
    getAdmins:(state,{payload})=>{
        state.currentAdmins=payload
    },
    logOut:(state)=>{
        state.detailStatusList=[]
        state.data=[]
        state.statusCount=0
        state.currentUsers=[[],[]]
        state.tickets=[]
        state.isLogin=false;
        state.currentAdmin='';
        state.currentTerminals='';
        state.currentTerminal='';
        localStorage.removeItem('AuthToken');
        localStorage.clear();
        sessionStorage.clear();
        Cookies.remove('AuthToken')
        Cookies.remove('exp')

    }
    

}
})
export const {loginStart,loginSuccess,logOut,addTerminalList,updateTerminal,TicketList,changeThemeShow,setUsers,setStatusCount,addTohistories,addDetailStatusList,getAdmins,addAdmin}=adminSlice.actions

export default adminSlice.reducer